import React from 'react';
import { authRoles } from 'app/auth';

// TODO Update path to use ID not name
export const JobManagerAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user,
	routes: [
		{
			path: '/jobs',
			component: React.lazy(() => import('./JobManagerApp'))
		}
	]
};
